export default __webpack_public_path__ + "static/media/logo.62566b3f.svg";